
import modalImage from 'services/utils/modalImage';

import CloseImagePopup from './assets/close-image-popup.svg';
import MaximizeImagePopup from './assets/maximize-image-popup.svg';

const PopupImage = (imageUrl, marker) => {
  let elementDivContainerPopup = document.createElement("div");
  elementDivContainerPopup.classList.add('container-img');
  let elementDivContainerButtons = document.createElement("div");
  elementDivContainerButtons.classList.add('container-buttons');
  let elementButtonMaximize = document.createElement("button");
  elementButtonMaximize.classList.add('custom-leaflet-popup-button-maximize');
  elementButtonMaximize.onclick = function() {                
    modalImage({
      imageUrl: imageUrl,
      callback: (confirmed) => {
        if (confirmed) marker.closePopup();
      },
    });
  };  
  let elementImgMaximize = document.createElement("img");
  elementImgMaximize.src = MaximizeImagePopup;            
  elementButtonMaximize.appendChild(elementImgMaximize);              
  let elementButtonClose = document.createElement("button");
  elementButtonClose.classList.add('custom-leaflet-popup-button-close');
  let elementImgClose= document.createElement("img");
  elementImgClose.src = CloseImagePopup;
  elementButtonClose.onclick = function() {                
    marker.closePopup();
  };
  elementButtonClose.appendChild(elementImgClose);

  elementDivContainerButtons.appendChild(elementButtonMaximize);
  elementDivContainerButtons.appendChild(elementButtonClose);
  elementDivContainerPopup.appendChild(elementDivContainerButtons);

  let elementImgContentPopup = document.createElement("img");
  elementImgContentPopup.src = imageUrl;
  elementImgContentPopup.style.width = '150px';
  elementImgContentPopup.style.height = 'auto';
  elementDivContainerPopup.appendChild(elementImgContentPopup);

  return elementDivContainerPopup;
};

export default PopupImage;

PopupImage.properties = {
  ignore: true,
};
